import React, { useState } from 'react';
import './App.css';
import OsrmView from './components/OsrmView';
import GoogleView from './components/GoogleView';

function App() {
  const [activeView, setActiveView] = useState('osrm');

  return (
    <div className="App">
      <header className="app-header">
        <h1>Route Planning Dashboard</h1>
        <p>Upload employee locations to generate optimized routes</p>
      </header>

      <div className="app-body">
        <nav className="sidebar">
          <ul className="sidebar-menu">
            <li
              className={activeView === 'osrm' ? 'sidebar-item active' : 'sidebar-item'}
              onClick={() => setActiveView('osrm')}
            >
              <span className="sidebar-icon">🗺️</span>
              <span className="sidebar-label">OSRM</span>
            </li>
            <li
              className={activeView === 'google' ? 'sidebar-item active' : 'sidebar-item'}
              onClick={() => setActiveView('google')}
            >
              <span className="sidebar-icon">🌐</span>
              <span className="sidebar-label">Google</span>
            </li>
          </ul>
        </nav>

        <main className="main-content">
          <div className="container">
            {activeView === 'osrm' && <OsrmView />}
            {activeView === 'google' && <GoogleView />}
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
